/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Owner_SettingInputs */

const vi_media_owner_setting = /** @type {(inputs: Media_Owner_SettingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cài đặt website`)
};

/**

* @param {Media_Owner_SettingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_owner_setting = /** @type {((inputs?: Media_Owner_SettingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Owner_SettingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_owner_setting(inputs)
});